import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { PreviewDataComponent } from './preview-data.component';
import { EmployeeSummaryPreviewModule } from './employee-summary-preview/employee-summary-preview.module';
import { AssetSummaryPreviewModule } from './asset-summary-preview/asset-summary-preview.module';
import { CustomerSummaryPreviewModule } from './customer-summary-preview/customer-summary-preview.module';
import { PropertySummaryPreviewModule } from './property-summary-preview/property-summary-preview.module';
import { OrganizationSummaryPreviewModule } from './organization-summary-preview/organization-summary-preview.module';
import { JobSummaryPreviewModule } from './job-summary-preview/job-summary-preview.module';

@NgModule({
  declarations: [
    PreviewDataComponent
  ],
  imports: [
    SharedModule,
    EmployeeSummaryPreviewModule,
    AssetSummaryPreviewModule,
    CustomerSummaryPreviewModule,
    PropertySummaryPreviewModule,
    OrganizationSummaryPreviewModule,
    JobSummaryPreviewModule
  ],
  exports:[
    PreviewDataComponent
  ]
})
export class PreviewDataModule { }
